import React,{useState} from 'react';
import {GlobalStyle} from '../../GlobalStyle'
import { Wrapper,Content, LogoImg,User,UserText} from './Header.styles';
import Knoppie from '../Knoppie';

const Header = ({username,role,Login,destination}) => (


 < Wrapper>
    <Content destination={destination}>
      
      {destination?<Knoppie
            destination={`/${destination}`}
            text={'Back'}
            clickable={true}
            ></Knoppie>:<div></div>}
      

        
        <h2>Awesome!</h2>
       
       {!Login?(<User>
       <UserText>
        
        <div>Logged in as: {username}</div>
        
        </UserText>
        
        <Knoppie
            text={"Logout"}
            clickable={true}
            destination={'/login'}
         ></Knoppie>

       </User>):("")}

    </Content>
         <GlobalStyle></GlobalStyle>
 </Wrapper>

)

export default Header;